import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Subject } from '../../../node_modules/rxjs';

const STORAGE_KEY = 'favorites';

@Injectable()
export class FavoriteProvider {
  changes: Subject<Array<any>> = new Subject<Array<any>>(); // Favorites list changes event

  constructor(private storage: Storage) {

  }

  /**
   * Check if a customer is added into the list
   */
  isFavorite(customer: number): Promise<boolean> {
    return this.getFavorites().then(result => {
      if (result) {
        if (result.indexOf(customer.toString()) !== -1) {
          return true;
        }
        return false;
      }
      return false;
    });
  }

  /**
   * Add a customer to favorites
   * @param customer id of the customer to be stored in the favorites
   */
  favorite(customer: number): void {
    // Get the current list from the storage
    this.getFavorites().then(result => {
      // If the list exists push the new value
      if (result && result.indexOf(customer) === -1) {
        result.push(customer.toString());
        this.storage.set(STORAGE_KEY, result);
        this.changes.next(result);
      } else {
        this.storage.set(STORAGE_KEY, [customer.toString()]);
        this.changes.next([customer.toString()]);
      }


    });
  }

  /**
   * Remove a customer from favorites
   * @param id id of the customer to be removed from favorites
   */
  unfavorite(id: number, type: string): void {
    this.getFavorites().then(result => {
      if (result) {
        // tslint:disable-next-line:no-var-keyword
        var index = result.indexOf(id.toString());
        result.splice(index, 1);
        this.storage.set(STORAGE_KEY, result);
        this.changes.next(result);
      }
    });

  }

  /**
   * Return a promise for the current list from the local DB
   */
  getFavorites(): Promise<any> {
    return this.storage.get(STORAGE_KEY);
  }
}



// WEBPACK FOOTER //
// ./src/providers/favorite/favorite.ts